import styled from 'styled-components'
import { breakpoints } from '../../css-variables'

export default styled.div`
    display: grid;
    grid-template-columns: 1fr;
    max-width: 1080px;
    margin: 58px 32px 0 32px;
    @media screen and ${breakpoints.laptopS} {
        grid-template-columns: 350px 1fr;
        margin: 88px auto 0;

        .right {
            padding-left: 56px;
            border-left: 6px solid #f3f3f3;
            width: 712px;
        }
    }

    .right {
        position: relative;
        margin: 0 auto;
        text-align: center;
    }

    @media only screen and (min-width: 1200px) {
        .mobile-only {
            display: none;
        }
    }
`
